<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-06 09:50:11
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-27 14:06:42
 * @FilePath: \合联\oms\src\view\forecastManagement\lingyang\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/forecastManagement/lingyang";
export default {
  name: "",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        remark: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("remarks", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("备注"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {},
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$tz("备注"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 },
              },
            },
          ],
        },
        packages: {
          config: {
            title: this.$tz("小包,信息"),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$tz("单号"),
                key: "airway_bill",
                minWidth: 110,
                header: {
                  copy: true,
                },
                copy: true,
              },
              {
                name: () => this.$tz("轨迹状态"),
                key: "status",
                minWidth: 110,
              },
              {
                name: () => this.$tz("轨迹时间"),
                key: "status_time",
                minWidth: 210,
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "order_status",
            placeholder() {
              return this.$tz("订单,状态");
            },
            component: "Select",
            options: [
              { label: this.$t("WAIT"), value: "WAIT" },
              { label: this.$t("TAIL"), value: "TAIL" },
              { label: this.$t("POD"), value: "POD" },
            ],
            optionsFn: "",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc({ origin: true });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center",
        },
        {
          name: () => this.$t("order_userRef"),
          key: "56package",
          minWidth: 130,
        },

        {
          name: () => this.$tz("尾程,单号"),
          key: "airway_bill",
          minWidth: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "created_time",
          minWidth: 210,
        },
        {
          name: () => this.$t("Tracker Status"),
          key: "status",
          minWidth: 130,
        },
        {
          name: () => this.$t("tracker_time"),
          key: "status_time",
          minWidth: 210,
        },
        {
          name: () => this.$tz("小包,信息"),
          key: "packages",
          minWidth: 130,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          disabled: ({ row }) => !row.packages.length,
          methods: {
            render({ value }) {
              return value.length;
            },
            export({ value }) {
              console.log("导出格式化");
              return value.map((t) => t.airway_bill).join("\n");
            },
            click({ row }) {
              this.$page.getModal("packages").open(null, function () {
                this.setTitle(this.$tz("小包,信息"));
                this.list = row.packages;
              });
            },
          },
        },
        {
          name: () => this.$tz("小包,总数"),
          key: "total_package",
          minWidth: 130,
        },
        {
          name: () => this.$tz("抵达,数量"),
          key: "done_package",
          minWidth: 130,
        },
        {
          name: () => this.$tz("是否,到齐"),
          key: "is_done",
          minWidth: 130,
          bind: {
            style({ row, value }) {
              return value ? {} : { color: "red" };
            },
          },
          methods: {
            render({ value }) {
              return value ? this.$tz("是") : this.$tz("否");
            },
          },
        },
        {
          name: () => this.$tz("订单,状态"),
          key: "order_status",
          minWidth: 110,
          methods: {
            render({ value }) {
              return this.$t(value);
            },
          },
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 110,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("备注"),
              type: "remark",
              fnName: "remark",
              bind: {
                type: "primary",
              },
              id: "",
            },
          ],
          methods: {
            remark({ row }) {
              this.getModal("remark").open(
                { id: row.id, remarks: row.remarks },
                function () {
                  this.setTitle(this.$tz("备注"));
                }
              );
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>